const zeroize = d => d <= 9 ? ('0'+d) : d
export const timeDisplay = d => zeroize(Math.floor(d / 3600))+':'+zeroize(Math.floor(d % 3600 / 60))+':'+zeroize(Math.floor(d % 60))
export const timeRange = (d , aprop = 'beginTime', bprop = 'endTime') => {
  return d.map(i => {
    return timeDisplay(i[aprop])+' - '+timeDisplay([bprop])
  })
}

export const str2time = d => {
  return d.split(':').reverse().reduce((t,c,idx) => (t + Math.pow(60 , idx) * parseInt(c)),0)
}

export const time2str = d => timeDisplay(d)

export const time2date = d => {
  return Math.round(new Date(d).getTime() / 86400000)
}

export const duration = (v) => {

  let d = Math.floor( v / 86400)
  let h = Math.floor( v / 3600) % 24
  let m = Math.floor( v / 60) % 60

  if(v < 60){
    return '少于1分钟'
  }else if(v < 3600){
    return `${m}分钟`
  }else if(v < 86400){
    return `${h}小时${m}分`
  }else{
    return `${d}天${h}小时${m}分`
  }
}

export default duration